// extracted by mini-css-extract-plugin
export default {"page":"consentDocuments_page__x-+C5","builderPage":"consentDocuments_builderPage__j4ZI5"};